/**
 * `SegmentedControl` (REDISENO-PANEL.md §2 "Controles segmentados" + §10
 * accesibilidad: "Pestañas y segmentados con role='tablist'/aria-pressed").
 * Shared by the later screens' tabs/periodo/agrupar/filtro controls — this
 * slice only builds the primitive.
 *
 * §10's literal "tablist/aria-pressed" combination is invalid ARIA: a
 * tablist's children must be role="tab" with aria-selected, not plain
 * buttons with aria-pressed. Resolved as a labelled `role="group"` with
 * `aria-pressed` toggle buttons instead — valid ARIA that keeps the same
 * "only one option active" semantics §10 was asking for.
 */
export interface SegmentedControlOption {
  value: string;
  label: string;
}

export function SegmentedControl({
  ariaLabel,
  options,
  value,
  onChange,
}: {
  ariaLabel: string;
  options: SegmentedControlOption[];
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <div className="v3-segmented" role="group" aria-label={ariaLabel}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          aria-pressed={option.value === value}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
